import React from "react";
import KycPageSection from "../sections/KycPageSection/Content";
const KycPage = () => {
  return <KycPageSection />;
};

export default KycPage;
